import { render, staticRenderFns } from "./LinkPreviewFileSize.vue?vue&type=template&id=59a37444&"
import script from "./LinkPreviewFileSize.vue?vue&type=script&lang=js&"
export * from "./LinkPreviewFileSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports